import { render } from "./StyleComp.vue?vue&type=template&id=405be99a&scoped=true&ts=true"
import script from "./StyleComp.vue?vue&type=script&lang=ts"
export * from "./StyleComp.vue?vue&type=script&lang=ts"

import "./StyleComp.vue?vue&type=style&index=0&id=405be99a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405be99a"]])

export default __exports__